import { pick } from "lodash";
import { DO_LOGOUT } from "../Login/actions";
import {
  LOAD_VIDEOLISTS,
  UPDATE_VIDEOLIST,
  SET_CURRENT_VIDEOLIST,
  SORT_VIDEOS,
  SORT_VIDEOLISTS,
  ADD_VIDEO_TO_LIST,
  LOADING,
  DELETE_VIDEOLISTS,
  PUT_VIDEOLISTS,
  TOGGLE_SELECTED_VIDEOLIST,
  TOGGLE_SELECTED_VIDEO,
  PUT_ALL_PUBLIC_VIDEO,
  SAVE_SORT_VIDEO_PARAMS,
  TOGGLE_LOADING_ALL_PUBLIC_VIDEO,
  SORT_VIDEOS_CURRENT,
  OPEN_ADDITIONAL_MENU,
  CLOSE_ADDITIONAL_MENU,
  PUT_SONGS,
} from "./actions";

const emptyMap = new Map();

const initialState = {
  loading: false,
  allVideolists: [],
  currentVideolist: undefined,
  allPublicVideos: emptyMap,
  allPublicVideos_loading: false,
  allPublicVideos_loaded_all: false,
  selected: [],
  selected_video: [],
  songs: [],
  assocPublicTracksTable: {
    sort_field: "",
    sort_dir: "",
  },
  currentVideoListTable: {
    sort_field: null,
    sort_dir: "up",
  },
  additional_menu: {
    opened: false,
    payload: null
  }
};
const sortByField = function (a, b, field, direction) {
  if (a[field] < b[field]) {
    return direction === "up" ? -1 : 1;
  }
  if (a[field] > b[field]) {
    return direction === "up" ? 1 : -1;
  }
  return 0;
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING_ALL_PUBLIC_VIDEO:
      return { ...state, allPublicVideos_loading: payload };

    case SAVE_SORT_VIDEO_PARAMS:
      return { ...state, assocPublicTracksTable: payload };

    case PUT_ALL_PUBLIC_VIDEO:
      return {
        ...state,
        allPublicVideos: payload,
        allPublicVideos_loading: false,
        allPublicVideos_loaded_all:
          payload.length < 50 || payload.length % 50 !== 0,
      }; // Возвращаем копию

    case SORT_VIDEOS_CURRENT:
      let currentVideolistSongs = state.currentVideolist
        ? [...state.currentVideolist.songs]
        : [];

      if (payload) {
        if (payload.sort_field === state.currentVideoListTable.sort_field)
          payload.direction =
            state.currentVideoListTable.direction === "up" ? "down" : "up";
        else payload.direction = "up";
      }

      if (!payload && state.currentVideoListTable.sort_field) {
        payload = state.currentVideoListTable;
      }

      if (payload?.sort_field === "name") {
        currentVideolistSongs.sort((a, b) =>
          sortByField(a, b, "name", payload.direction),
        );
      } else if (payload?.sort_field === "duration") {
        currentVideolistSongs.sort((a, b) =>
          sortByField(a, b, "cliptime", payload.direction),
        );
      } else if (payload?.sort_field === "added") {
        currentVideolistSongs.sort((a, b) =>
          sortByField(a, b, "ctime", payload.direction),
        );
      } else if (payload?.sort_field === "id") {
        currentVideolistSongs.sort((a, b) =>
          sortByField(a, b, "id", payload.direction),
        );
      }

      return {
        ...state,
        songs: [...currentVideolistSongs],
        currentVideoListTable: payload || state.currentVideoListTable,
      };
    case SORT_VIDEOLISTS:
      if (payload.sort_type === "name") {
        return {
          ...state,
          allVideolists: Array.from(state.allVideolists).sort((a, b) => {
            if (a.name < b.name) {
              return payload.direction === "up" ? -1 : 1;
            }
            if (a.name > b.name) {
              return payload.direction === "up" ? 1 : -1;
            }
            return 0;
          }),
        };
      } else if (payload.sort_type === "songs") {
        return {
          ...state,
          allVideolists: Array.from(state.allVideolists).sort((a, b) => {
            if (a.totalcount < b.totalcount) {
              return payload.direction === "up" ? -1 : 1;
            }
            if (a.totalcount > b.totalcount) {
              return payload.direction === "up" ? 1 : -1;
            }
            return 0;
          }),
        };
      } else if (payload.sort_type === "size") {
        return {
          ...state,
          allVideolists: Array.from(state.allVideolists).sort((a, b) => {
            if (a.totalsize < b.totalsize) {
              return payload.direction === "up" ? -1 : 1;
            }
            if (a.totalsize > b.totalsize) {
              return payload.direction === "up" ? 1 : -1;
            } else {
              return 0;
            }
          }),
        };
      } else if (payload.sort_type === "duration") {
        return {
          ...state,
          allVideolists: Array.from(state.allVideolists).sort((a, b) => {
            if (a.totaltime === null) {
              a.totaltime = `00:00:00`;
            }
            if (b.totaltime === null) {
              b.totaltime = `00:00:00`;
            }
            let atot =
              Number(a.totaltime.split(":")[0]) * 3600 +
              Number(a.totaltime.split(":")[1]) * 60 +
              Number(a.totaltime.split(":")[2]);
            let btot =
              Number(b.totaltime.split(":")[0]) * 3600 +
              Number(b.totaltime.split(":")[1]) * 60 +
              Number(b.totaltime.split(":")[2]);
            if (atot < btot) {
              return payload.direction === "up" ? -1 : 1;
            }
            if (atot > btot) {
              return payload.direction === "up" ? 1 : -1;
            }
            return 0;
          }),
        };
      }
    // case LOAD_VIDEOLISTS:
    //   const all = state.allVideolists ? [...state.allVideolists] : [];
    //   return {
    //     ...state,
    //     allVideolists: [],
    //     selected: [...state.selected],
    //   };
    case PUT_VIDEOLISTS:
      return {
        ...state,
        allVideolists: payload.videolists,
        //tracksAssoc: payload.tracksAssoc,
      };
    case SET_CURRENT_VIDEOLIST:
      return {
        ...state,
        currentVideolist: payload.videolist,
        //selected: [payload.videolist.id]
      };
    case UPDATE_VIDEOLIST:
      
      return {
        ...state,
        allVideolists: state.allVideolists.map((videolist) => {
        if (videolist.id === payload.videolist?.id) {
          console.log({ videolist, payload });
          if ('totalcount' in payload.videolist) {
            videolist = {
              ...videolist,
              ...pick(payload.videolist, ['totalcount', 'totaltime', 'totalsize2'])
            }

          }
          if (payload.videolist.songs)
            videolist.songs = [...payload.videolist.songs];
        }
        return videolist;
      }),
        selected: [payload.videolist.id],
      };
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case ADD_VIDEO_TO_LIST:
      state.allVideolists.map((videolist) => {
        if (videolist.id === payload.id_videolist) {
          videolist.songs = [...payload.songs];
        }
      });
      return {
        ...state,
        allVideolists: state.allVideolists,
      };
    case DELETE_VIDEOLISTS:
      return {
        ...state,
        loading: true,
        selected: [],
      };
    case TOGGLE_SELECTED_VIDEOLIST:
      const { id, selected, simple, required } = payload;
      if (simple === true) {
        return {
          ...state,
          selected,
        };
      } else if (required === true) {
        return {
          ...state,
          selected:
            state.selected.indexOf(id) === -1
              ? state.selected.concat([id])
              : state.selected,
        };
      } else if (required === false) {
        return {
          ...state,
          selected:
            state.selected.indexOf(id) !== -1
              ? state.selected.filter((playlistId) => playlistId !== id)
              : state.selected,
        };
      } else {
        return {
          ...state,
          selected:
            state.selected.indexOf(id) === -1
              ? state.selected.concat([id])
              : state.selected.filter((playlistId) => playlistId !== id),
        };
      }
    case TOGGLE_SELECTED_VIDEO:
      const { id_video, selected_video, onlyOne, setAll } = payload;
      if (setAll === true) {
        return {
          ...state,
          selected_video: id_video,
        };
      } else if (selected_video === true) {
        return {
          ...state,
          selected_video:
            state.selected_video.indexOf(id_video) === -1
              ? state.selected_video.concat([id_video])
              : state.selected_video,
        };
      } else if (selected_video === false) {
        return {
          ...state,
          selected_video:
            state.selected_video.indexOf(id_video) !== -1
              ? state.selected_video.filter((objectId) => objectId !== id_video)
              : state.selected_video,
        };
      } else {
        if (onlyOne === true) {
          return {
            ...state,
            selected_video:
              state.selected_video.indexOf(id_video) === -1 ? [id_video] : [],
          };
        } else {
          return {
            ...state,
            selected_video:
              state.selected_video.indexOf(id_video) === -1
                ? state.selected_video.concat([id_video])
                : state.selected_video.filter(
                  (objectId) => objectId !== id_video,
                ),
          };
        }
      }
    case OPEN_ADDITIONAL_MENU:
      return {
        ...state,
        additional_menu: {
          open: true,
          payload
        }
      }

    case CLOSE_ADDITIONAL_MENU:
      return {
        ...state,
        additional_menu: {
          open: false,
          payload
        }
      }
    case PUT_SONGS:
      return {
        ...state,
        songs: payload
      }

    case DO_LOGOUT:
      return initialState;
  }
  return state;
};

export default reducer;
